const globalConfig = {
  xueersi: {
    id: 10, // x-business-id
    brand: 1,
    baseUrl: "https://trade.xueersi.com", // 学而思域名不走收敛
  },
  "classa-z": {
    id: 91, // x-business-id
    brand: 169,
    baseUrl: "https://app.classa-z.com/trade", // 小班域名必须走收敛
  },
};
const getUrlHost = function () {
  return window.location.hostname.split(".")[1];
};
const X_BUSINESSLINE_ID =
  globalConfig[getUrlHost()]?.id || globalConfig.xueersi.id;
const X_BRAND = globalConfig[getUrlHost()]?.brand || globalConfig.xueersi.brand;
export { globalConfig, getUrlHost, X_BUSINESSLINE_ID, X_BRAND };
